/* eslint-disable no-shadow */
export enum enumServerOS {
  WindowsServer = 1,
  SLESSAP = 2,
  RedHatLinux = 3,
  OracleLinux = 4,
  DebianLinux = 5,
  CiscoOS = 6,
  FortiOS = 7,
  CentOS = 8,
  Suse = 9,
  UbuntuServer = 10,
  Other64bit = 11,
  Fedora = 12,
  Linux = 13
}

export const enumServerOSLabel = new Map<enumServerOS, string>([
  [enumServerOS.WindowsServer, 'Windows Server'],
  [enumServerOS.SLESSAP, 'SLESSAP'],
  [enumServerOS.RedHatLinux, 'RedHat Linux'],
  [enumServerOS.OracleLinux, 'Oracle Linux'],
  [enumServerOS.DebianLinux, 'Debian Linux'],
  [enumServerOS.CiscoOS, 'Cisco OS'],
  [enumServerOS.FortiOS, 'Forti OS'],
  [enumServerOS.CentOS, 'CentOS'],
  [enumServerOS.Suse, 'Suse'],
  [enumServerOS.UbuntuServer, 'Ubuntu Server'],
  [enumServerOS.Other64bit, 'Other 64-bit'],
  [enumServerOS.Fedora, 'Fedora'],
  [enumServerOS.Linux, 'Linux']
]);
/* eslint-enable no-shadow */
